export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9457.409d47a1.jpg";